/*
 * Through Your Eyes: Instagram handle and email rules (D-07). Pure functions, shared by the
 * entry page (window.BelantaraTyeHandle) and the node unit tests
 * (tools/through-your-eyes/handle.test.mjs). Each error key maps to the copy block entry
 * error_<key> and the locale key through_your_eyes.errors.<key>.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.BelantaraTyeHandle = api;
})(typeof self !== 'undefined' ? self : this, function () {
  const HANDLE_MAX = 30;

  // All whitespace and one leading '@' are removed silently; the handle is lowercased.
  function cleanHandle(raw) {
    return String(raw == null ? '' : raw)
      .replace(/\s+/g, '')
      .replace(/^@/, '')
      .toLowerCase();
  }

  // Checks a cleaned handle. Order: empty, characters, length, edge full stop, double full stop.
  function handleError(cleaned) {
    const value = String(cleaned == null ? '' : cleaned);
    if (value === '') return 'handle_missing';
    if (/[^a-z0-9._]/.test(value)) return 'handle_chars';
    if (value.length > HANDLE_MAX) return 'handle_length';
    if (value.charAt(0) === '.' || value.charAt(value.length - 1) === '.') return 'handle_edge_dot';
    if (value.indexOf('..') !== -1) return 'handle_double_dot';
    return null;
  }

  // Trimmed and lowercased; exactly one '@', no whitespace, and a '.' inside the domain part
  // with text on either side.
  function emailError(raw) {
    const value = String(raw == null ? '' : raw)
      .trim()
      .toLowerCase();
    if (value === '') return 'email_missing';
    if (/\s/.test(value)) return 'email_invalid';
    const parts = value.split('@');
    if (parts.length !== 2 || parts[0] === '') return 'email_invalid';
    const domain = parts[1];
    const dot = domain.lastIndexOf('.');
    if (dot <= 0 || dot === domain.length - 1) return 'email_invalid';
    return null;
  }

  return { cleanHandle, handleError, emailError };
});
